import { Link } from "react-router-dom";

const SamenGroeienMarquee = () => {
  const items = Array.from({ length: 8 });
  return (
    <section className="bg-primary overflow-hidden py-8 md:py-12">
      <Link to="/kennismaken" className="block group" aria-label="Samen groeien - plan gratis gesprek">
        <div className="relative flex whitespace-nowrap">
          <div className="flex animate-marquee shrink-0 items-center">
            {items.map((_, i) => (
              <span
                key={`a-${i}`}
                className="accent-serif text-[12vw] md:text-[10vw] leading-none text-primary-foreground/25 px-8 transition-colors duration-500 group-hover:text-primary-foreground/40"
              >
                Samen Groeien<span className="not-italic">?</span>
              </span>
            ))}
          </div>
          <div className="flex animate-marquee shrink-0 items-center" aria-hidden="true">
            {items.map((_, i) => (
              <span
                key={`b-${i}`}
                className="accent-serif text-[12vw] md:text-[10vw] leading-none text-primary-foreground/25 px-8 transition-colors duration-500 group-hover:text-primary-foreground/40"
              >
                Samen Groeien<span className="not-italic">?</span>
              </span>
            ))}
          </div>
        </div>
      </Link>
    </section>
  );
};

export default SamenGroeienMarquee;
